import { ActionTypes } from 'redux-undo';
import * as labelPass from '../labelPass';
import { getItemLabelPassState } from '../labelPass/labelPass.selectors';
import * as tools from './toolsState.slice';

// Capture the action creator once at module load. Referencing it directly here
// (rather than re-reading labelPass.actions.setInitialLabelPass live below) keeps
// its RTK `.match` static intact even when a test does
// `vi.spyOn(labelPass.actions, 'setInitialLabelPass')` — a spy replaces the live
// property with a plain fn that has no `.match`, which would throw at call time.
const setInitialLabelPass = labelPass.actions.setInitialLabelPass;

const matchingActions = [
  labelPass.actions.setLastUpdated,
  labelPass.actions.addObservation,
  labelPass.actions.setLastUpdatedByRegion,
  labelPass.actions.deleteObservation,
  labelPass.actions.deleteRegion,
  labelPass.actions.clear,
  setInitialLabelPass,
];

export const toolsMiddleware = store => next => action => {
  const result = next(action);

  if (
    matchingActions.some(matchingAction => matchingAction.match(action)) ||
    action.type === ActionTypes.UNDO ||
    action.type === ActionTypes.REDO
  ) {
    const { lastUpdatedObs, observations } = getItemLabelPassState(store.getState());

    if (lastUpdatedObs) {
      store.dispatch(
        tools.actions.setNextObs({
          code: lastUpdatedObs.code,
          status: lastUpdatedObs.status,
          index: lastUpdatedObs.index,
        })
      );
    } else if (
      observations.length === 0 &&
      !setInitialLabelPass.match(action)
    ) {
      // Clear the pending selection only for user-driven changes that empty the
      // observation list (e.g. deleting the last observation). Do NOT clear on
      // the initial pass load: it can fire repeatedly during hydration and would
      // fight the single-observation-type auto-selection (useViewportTool), which
      // keeps the sole observation/tool selected while the list is still empty.
      // Clearing it there leaves the drawing tool inactive at draw time, so the
      // drawn annotation is never created/linked and no observation appears.
      store.dispatch(tools.actions.clear());
    }
  }

  return result;
};
